// Modules
import styled from 'styled-components';
import Grid from '@material-ui/core/Grid';

// Web Components
import {
	BiuSelect,
	BiuSearchBar,
	BiuRoundedButton,
	BiuA,
	BiuCalendar,
} from '../../biu-web-components/src/components';
import * as TYPO from '../../styles/common/typo.styles';

// Types
import { styledComponentProps } from '../../types/theme';

export const Select = styled(BiuSelect)`
	width: inherit;
	.biu-select {
		width: auto;
	}
	.biu-select__option-text:first-letter {
		text-transform: uppercase;
	}
`;

export const SearchBar = styled(BiuSearchBar)`
	@media ${({ theme }: styledComponentProps): string => theme.breakpoints.md} {
		width: 100%;
	}
`;

export const DateFilters = styled.div`
	display: flex;
	align-items: center;
	justify-content: flex-start;
	flex-direction: row-reverse;
	width: 100%;
	@media ${({ theme }: styledComponentProps): string => theme.breakpoints.sm} {
		flex-direction: column;
		justify-content: center;
	}
`;

export const FilterView = styled.div`
min-width: 1200px;
@media ${({ theme }: styledComponentProps): string => theme.breakpoints.lg} {
	min-width: auto;

}
	@media ${({ theme }: styledComponentProps): string => theme.breakpoints.sm} {
		min-width: auto;

		padding: 30px;
		background: white;
	}
`;

export const ParamFilters = styled(Grid)`
	flex-direction: row-reverse;
	margin-top: 32px !important;
	align-items: center;
`;

export const Reset = styled(BiuRoundedButton)<any>`
	margin-right: ${({ direction }: any) =>
		direction === 'rtl' ? 'auto' : 'unset'};
	margin-left: ${({ direction }: any) =>
		direction === 'rtl' ? 'unset' : 'auto'};
`;

export const Calendar = styled(BiuCalendar)`
	margin-right: 1rem;
	@media ${({ theme }: styledComponentProps): string => theme.breakpoints.sm} {
		order: 3;
		margin-right: 0;
	}
	.biu-calendar__dates {
		display: flex;
		justify-content: space-between;
		width: 100%;
		flex-direction: ${({language}: any) => language === 'rtl' ? 'row-reverse': 'row'};
	}
`;

export const A = styled(BiuA)<any>`
	margin-right: 1.5rem;
	@media ${({ theme }: styledComponentProps): string => theme.breakpoints.sm} {
		order: ${({ order }: styledComponentProps): any => order};
		margin-right: 0;
	} ;
`;

export const DatePickers = styled.div`
	display: flex;
	flex-direction: row-reverse;
	@media ${({ theme }: styledComponentProps): string => theme.breakpoints.sm} {
		display: grid;
		grid-template-columns: repeat(2, 50%);
		width: 100%;
		grid-gap: 1rem;
		margin-top: 1rem;
	}
`;

export const SelectedDateView = styled(TYPO.Body)<any>`

	@media ${({ theme }: styledComponentProps): string => theme.breakpoints.sm} {
		margin-top: 1rem;
		margin-right: ${({direction}: styledComponentProps): string=> direction === 'rtl' ? 'unset': 'auto'};
		margin-left: ${({direction}: styledComponentProps): string=> direction === 'ltr' ? 'unset': 'auto'};
	}
`;
